import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {News} from 'src/app/core/models/news';

@Component({
  selector: 'app-news-teaser-card',
  templateUrl: './news-teaser-card.component.html',
  styleUrls: ['./news-teaser-card.component.scss'],
})
export class NewsTeaserCardComponent {
  random = Math.round(Math.random() * 300);
  @Input() public news?: News;
  @Input() multiClaims?: boolean;

  /** URL to use as background image (either the news image or a fallback) */
  public bgImageUrl = 'assets/img/no-image-news.svg';

  ngOnInit() {
    this.updateBg();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['news']) {
      this.updateBg();
    }
  }

  private updateBg() {
    const fallback = 'assets/img/no-image-news.svg';
    if (!this.news || !this.news.metadata || !this.news.metadata.picture) {
      this.bgImageUrl = fallback;
      return;
    }

    const src = this.news.metadata.picture;
    // Preload image to detect validity
    const img = new Image();
    img.onload = () => {
      // valid image
      this.bgImageUrl = src;
    };
    img.onerror = () => {
      // invalid or failed to load
      this.bgImageUrl = fallback;
    };
    img.src = src;
  }
}
